import React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { useTranslation } from 'react-i18next';
import { IconButton, InputAdornment } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { FIELD_PADDING } from '../SettlePayment/const';

const SuperAgentBranchesAutocomplete = ({ profile, bookingFromBranch, onChange }) => {
	const { t } = useTranslation();

	const getDefaultValue = () => {
		return profile?.company_branches?.find((c) => c && c._id === bookingFromBranch) || null;
	};

	const filterOptions = () => {
		return createFilterOptions({
			matchFrom: 'start',
			stringify: (branch) => branch.name,
		});
	};

	return (
		<Autocomplete
			value={getDefaultValue()}
			options={profile?.company_branches}
			getOptionLabel={(branch) => branch.name}
			filterOptions={filterOptions()}
			onChange={(e, value) => onChange(value._id)}
			disableClearable={true}
			size="small"
			renderInput={(params) => (
				<TextField
					{...params}
					placeholder={t('FindByBranchName')}
					label=""
					variant="outlined"
					fullWidth
					sx={FIELD_PADDING}
					InputProps={{
						...params.InputProps,
						endAdornment: (
							<>
								{bookingFromBranch ? (
									<InputAdornment position="end">
										<IconButton onClick={() => onChange?.(null)} disableRipple size="small">
											<CloseIcon />
										</IconButton>
									</InputAdornment>
								) : (
									params.InputProps.endAdornment
								)}
							</>
						),
					}}
				/>
			)}
		/>
	);
};

export default SuperAgentBranchesAutocomplete;
